import styled from "styled-components";
import { Image as AntImage } from "antd";

export const NotiContainer = styled.div`
  height: 100vh;
  position: relative;

  .infinite-scroll-component__outerdiv {
    height: calc(100vh - 155px);
  }

  .infinite-scroll-component {
    height: 100% !important;
    overflow-x: hidden !important;
  }
`;

export const NotiCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-left: 12px;
  padding-right: 12px;
`;

export const NotiDate = styled.div`
  font-size: 12px;
  font-weight: 400;
  margin-top: 16px;
  margin-bottom: 16px;
  color: ${props => props.theme.dark2}
`;

export const NotiCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  background-color: #fff;
  width: 100%;
  border-bottom: 1px solid #FAF6F1;
`;

export const NotiTitle = styled.p`
  color: ${props => props.theme.textColor};
  font-size: 14px;
  margin-top: 10px;
  font-weight: 600;
`;

export const NotiDes = styled.p`
  color: ${props => props.theme.dark2};
  font-size: 12px;
  margin-top: 8px;
  padding-top: 0px;
  font-weight: 400;
`;

export const NotiTimeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  width: 100%;
`;

export const NotiTime = styled.span`
  color: ${props => props.theme.dark2};
  font-size: 12px;
  font-weight: 400;
`;

export const NotiNew = styled.span`
  background: ${props => props.theme.golden};
  padding: 3px 16px 3px 16px;
  border-radius: 23px;
`;

export const Mute = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    180deg,
    rgba(109, 29, 122, 1) 0%,
    rgba(148, 55, 140, 1) 100%
  );
  height: 62px;
  position: sticky;
  bottom: 0;
  width: 100%;
  margin-top: 16px;
`;

export const MuteTitle = styled.p`
  color: #fff;
  font-size: 16px;
`;

export const SpinWrapper = styled.div`
  padding-top: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 75px);
`;

export const EmptyText = styled.div`
  padding-top: 24px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const Image = styled(AntImage).attrs({
  preview: false,
})`
  width: 100%;
  object-fit: cover;
  aspect-ratio: 1 / 0.4;
  border-radius: 12px;
  margin-bottom: 6px;
`;
